export default __webpack_public_path__ + "static/media/ic_tokelau.73fcf010.svg";